import React, { useState, useEffect } from "react";
import "../assets/css/RegistrationForm.css";
import OtpInput from 'react-otp-input';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-select";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const RegistrationForm = () => {

    // State PIN code mapping data
    const statePinMapping = {
        "Andhra Pradesh": { range: [500001, 599999] },
        "Arunachal Pradesh": { range: [791001, 799999] },
        "Assam": { range: [781001, 799999] },
        "Bihar": { range: [800001, 899999] },
        "Chhattisgarh": { range: [490001, 499999] },
        "Goa": { range: [403001, 409999] },
        "Gujarat": { range: [380001, 399999] },
        "Haryana": { range: [121001, 129999] },
        "Himachal Pradesh": { range: [171001, 179999] },
        "Jharkhand": { range: [800001, 899999] },
        "Karnataka": { range: [560001, 569999] },
        "Kerala": { range: [680001, 699999] },
        "Madhya Pradesh": { range: [450001, 499999] },
        "Maharashtra": { range: [400001, 499999] },
        "Manipur": { range: [795001, 799999] },
        "Meghalaya": { range: [793001, 799999] },
        "Mizoram": { range: [796001, 799999] },
        "Nagaland": { range: [797001, 799999] },
        "Odisha": { range: [751001, 799999] },
        "Punjab": { range: [140001, 149999] },
        "Rajasthan": { range: [302001, 399999] },
        "Sikkim": { range: [737101, 799999] },
        "Tamil Nadu": { range: [600001, 699999] },
        "Telangana": { range: [500001, 599999] },
        "Tripura": { range: [799001, 799999] },
        "Uttar Pradesh": { range: [200001, 299999] },
        "Uttarakhand": { range: [248001, 259999] },
        "West Bengal": { range: [700001, 799999] },
        "Andaman and Nicobar Islands": { range: [744101, 744999] },
        "Chandigarh": { range: [160001, 160099] },
        "Dadra and Nagar Haveli and Daman and Diu": { range: [396001, 396999] },
        "Delhi": { range: [110001, 119999] },
        "Jammu and Kashmir": { range: [180001, 199999] },
        "Ladakh": { range: [194101, 199999] },
        "Lakshadweep": { range: [682555, 699999] },
        "Puducherry": { range: [605001, 609999] },
    };

    const [ipAddress, setIpAddress] = useState("");
    const [showOtpSection, setShowOtpSection] = useState(false);
    const [errorResponce, setErrorResponce] = useState("");
    const [otp, setOtp] = useState("");
    const [resendDisabled, setResendDisabled] = useState(false);
    const [resendTimer, setResendTimer] = useState(0);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);



    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
        businessName: "",
        phoneNumber: "",
        address: "",
        state: "",
        zipCode: "",
        terms: false,
        createWebStore: false,
    });

    const indianStatesWithDetails = [
        { state: "Andhra Pradesh", capital: "Amaravati", zipcode: "522503" },
        { state: "Arunachal Pradesh", capital: "Itanagar", zipcode: "791111" },
        { state: "Assam", capital: "Dispur", zipcode: "781005" },
        { state: "Bihar", capital: "Patna", zipcode: "800001" },
        { state: "Chhattisgarh", capital: "Raipur", zipcode: "492001" },
        { state: "Goa", capital: "Panaji", zipcode: "403001" },
        { state: "Gujarat", capital: "Gandhinagar", zipcode: "382010" },
        { state: "Haryana", capital: "Chandigarh", zipcode: "160001" },
        { state: "Himachal Pradesh", capital: "Shimla", zipcode: "171001" },
        { state: "Jharkhand", capital: "Ranchi", zipcode: "834001" },
        { state: "Karnataka", capital: "Bengaluru", zipcode: "560001" },
        { state: "Kerala", capital: "Thiruvananthapuram", zipcode: "695001" },
        { state: "Madhya Pradesh", capital: "Bhopal", zipcode: "462001" },
        { state: "Maharashtra", capital: "Mumbai", zipcode: "400001" },
        { state: "Manipur", capital: "Imphal", zipcode: "795001" },
        { state: "Meghalaya", capital: "Shillong", zipcode: "793001" },
        { state: "Mizoram", capital: "Aizawl", zipcode: "796001" },
        { state: "Nagaland", capital: "Kohima", zipcode: "797001" },
        { state: "Odisha", capital: "Bhubaneswar", zipcode: "751001" },
        { state: "Punjab", capital: "Chandigarh", zipcode: "160001" },
        { state: "Rajasthan", capital: "Jaipur", zipcode: "302001" },
        { state: "Sikkim", capital: "Gangtok", zipcode: "737101" },
        { state: "Tamil Nadu", capital: "Chennai", zipcode: "600001" },
        { state: "Telangana", capital: "Hyderabad", zipcode: "500001" },
        { state: "Tripura", capital: "Agartala", zipcode: "799001" },
        { state: "Uttar Pradesh", capital: "Lucknow", zipcode: "226001" },
        { state: "Uttarakhand", capital: "Dehradun", zipcode: "248001" },
        { state: "West Bengal", capital: "Kolkata", zipcode: "700001" },
        { state: "Andaman and Nicobar Islands", capital: "Port Blair", zipcode: "744101" },
        { state: "Chandigarh", capital: "Chandigarh", zipcode: "160001" },
        { state: "Dadra and Nagar Haveli and Daman and Diu", capital: "Daman", zipcode: "396210" },
        { state: "Delhi", capital: "New Delhi", zipcode: "110001" },
        { state: "Jammu and Kashmir", capital: "Srinagar (Summer), Jammu (Winter)", zipcode: "190001 (Srinagar), 180001 (Jammu)" },
        { state: "Ladakh", capital: "Leh", zipcode: "194101" },
        { state: "Lakshadweep", capital: "Kavaratti", zipcode: "682555" },
        { state: "Puducherry", capital: "Puducherry", zipcode: "605001" }
    ];

    useEffect(() => {
        // Only start the timer if there's an error message
        if (errorResponce) {
            const timer = setTimeout(() => {
                setErrorResponce("");
            }, 5000);

            // Cleanup function to clear the timeout if component unmounts
            return () => clearTimeout(timer);
        }
    }, [errorResponce]);

    useEffect(() => {
        let interval;
        if (resendTimer > 0) {
            interval = setInterval(() => {
                setResendTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        } else {
            setResendDisabled(false);
        }

        return () => clearInterval(interval);
    }, [resendTimer]);

    useEffect(() => {
        console.log("Terms updated:", formData.terms);
    }, [formData.terms]);

    useEffect(() => {
        const fetchIPAddress = async () => {
            try {
                const response = await fetch("https://api.ipify.org?format=json");
                const data = await response.json();
                setIpAddress(data.ip);
            } catch (error) {
                console.error("Error fetching IP address:", error);
            }
        };

        fetchIPAddress();
    }, []);

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [passwordRequirements, setPasswordRequirements] = useState({
        length: false,
        number: false,
        capital: false,
        special: false,
    });

    // Function to validate PIN code based on selected state
    const validatePinCode = (pinCode, state) => {
        if (state && pinCode) {
            const pin = parseInt(pinCode, 10);
            const stateRange = statePinMapping[state]?.range;

            if (stateRange && pin >= stateRange[0] && pin <= stateRange[1]) {
                return ""; // Valid PIN code
            } else {
                return "Invalid Pin code for the selected state.";
            }
        }
        return ""; // No validation if either state or PIN code is missing
    };

    const validatePassword = (password) => {
        const requirements = {
            length: password.length >= 8,
            number: /\d/.test(password),
            capital: /[A-Z]/.test(password),
            special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        };
        setPasswordRequirements(requirements);
        return Object.values(requirements).every(Boolean);
    };

    const validateField = (name, value) => {
        if (value === undefined || value === null) {
            return "This field is required";
        }

        // Special handling for checkboxes
        if (name === "terms") {
            return value === true ? "" : "You must accept the terms and conditions";
        }

        // Add handling for createWebStore checkbox
        if (name === "createWebStore") {
            return ""; // This is optional, so no validation error
        }

        if (typeof value !== "string") {
            return "Invalid input";
        }

        switch (name) {
            case "firstName":
            case "lastName":
                return value.trim() === "" ? "This field is required" : "";
            case "email":
                return !value.trim()
                    ? "This field is required"
                    : !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
                        ? "Invalid email address"
                        : "";
            case "password":
                return !value.trim()
                    ? "Password is required"
                    : !validatePassword(value)
                        ? "Password does not meet requirements"
                        : "";
            case "confirmPassword":
                return !value.trim()
                    ? "Please confirm your password"
                    : value !== formData.password
                        ? "Passwords do not match"
                        : "";
            case "state":
                return value.trim() === "" ? "Please select a state" : "";
            case "phoneNumber":
                if (!value.trim()) return "Phone number is required";
                if (!/^\d+$/.test(value)) return "Only digits are allowed";
                if (value.length !== 10) return "Phone number must be 10 digits";
                return "";


            case "zipCode":
                return !value.trim()
                    ? "ZIP code is required"
                    : !/^\d{6}$/.test(value)
                        ? "ZIP code must be 6 digits"
                        : validatePinCode(value, formData.state);
            default:
                return value.trim() === "" ? "This field is required" : "";
        }
    };
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === "checkbox" ? checked : value;

        setFormData((prev) => ({
            ...prev,
            [name]: newValue,
        }));

        // Handle state selection specially
        if (name === "state" && value) {
            const selectedState = indianStatesWithDetails.find(
                (state) => state.state === value
            );
            if (selectedState) {
                // For states with multiple codes like J&K, take the first zipcode
                const zipCode = selectedState.zipcode.split(',')[0].split(' ')[0];
                setFormData((prev) => ({
                    ...prev,
                    [name]: newValue,

                }));

                // Validate the ZIP code after updating
                setTimeout(() => {
                    const zipError = validatePinCode(zipCode, value);
                    if (zipError) {
                        setErrors(prev => ({
                            ...prev,
                            zipCode: zipError
                        }));
                    } else {
                        setErrors(prev => ({
                            ...prev,
                            zipCode: ""
                        }));
                    }
                }, 0);
            }
        }

        // For ZIP code changes, validate against selected state
        if (name === "zipCode" && formData.state) {
            const zipError = validatePinCode(value, formData.state);
            if (zipError) {
                setErrors(prev => ({
                    ...prev,
                    zipCode: zipError
                }));
            } else {
                setErrors(prev => ({
                    ...prev,
                    [name]: validateField(name, newValue)
                }));
            }
        } else {
            // For other fields, use standard validation
            const error = validateField(name, newValue);
            setErrors((prev) => ({
                ...prev,
                [name]: error,
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        let isValid = true;

        Object.keys(formData).forEach((key) => {
            let error;

            // Special handling for ZIP code validation against state
            if (key === "zipCode" && formData.state) {
                error = validatePinCode(formData.zipCode, formData.state);
                if (!error) {
                    error = validateField(key, formData[key]);
                }
            } else {
                error = validateField(key, formData[key]);
            }

            if (error) {
                newErrors[key] = error;
                isValid = false;
                console.log(`Validation failed for ${key}:`, error);
            }
        });

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Form submission started");
        console.log("Current formData:", formData);

        // Log validation status for each field
        Object.keys(formData).forEach((key) => {
            const error = validateField(key, formData[key]);
            console.log(`Validating ${key}:`, error || "Valid");
        });

        const isValid = validateForm();
        console.log("Form validation result:", isValid);

        if (!isValid) {
            console.log("Form validation failed. Current errors:", errors);
            return;
        }

        setIsSubmitting(true);

        const payload = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            email_address: formData.email,
            password: formData.password,
            business_name: formData.businessName,
            phone_number: formData.phoneNumber,
            address: formData.address,
            state: formData.state,
            zipcode: formData.zipCode,
            terms_accepted: String(formData.terms),
            ip_address: ipAddress,
            create_web_store: formData.createWebStore,
        };

        console.log("Payload being sent:", payload);

        try {
            console.log("Attempting API call...");
            const response = await fetch(
                process.env.REACT_APP_APIURL + "business/signup",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            console.log("API Response status:", response);
            const data = await response.json();

            console.log("Success response:", data);
            console.log("------- status:", data.status);

            if (data.status == "success") {
                setShowOtpSection(true);
                setResendDisabled(false);
            } else {
                toast.error(data.message, {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                // setErrorResponce(data.message);
            }


        } catch (error) {
            console.error("Error during submission:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const verifyOTP = async (otp) => {
        console.log("otp")
        console.log(otp)
        if (otp.length !== 4) {
            toast.error('Please enter a valid 4-digit OTP.', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return;
        }

        setIsSubmitting(true);

        try {
            // Verify OTP
            const verifyResponse = await fetch(
                process.env.REACT_APP_APIURL + "business/verify",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        email_address: formData.email,
                        otp: otp,
                    }),
                }
            );

            if (!verifyResponse.ok) {
                throw new Error(
                    `OTP verification failed with status: ${verifyResponse.status}`
                );
            }
            const data = await verifyResponse.json();
            console.log("verifyResponse:", data);

            window.localStorage.setItem("email_address", data.result.email_address);
            window.localStorage.setItem("user_id", data.result.user_id);
            window.localStorage.setItem("signup", data.result.signup);
            if (data.result.signup === "user") {
                window.localStorage.setItem("business_id", data.result.business_id);
            }
            toast.success('OTP verified, Sign-up Successful', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setTimeout(() => {
                console.log("Accessed");
                window.location.href = `/`;
            }, 1000);

            setOtp("");
        } catch (error) {
            console.error("Error during OTP verification or registration:", error);

            if (error.message.includes("OTP verification failed")) {
                toast.error('Something went wrong. Please try again later.', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                console.log("Registration failed. Please try again.");
            }
        } finally {
            setIsSubmitting(false);
        }
    };
    // Handle Resend OTP
    const handleResendOTP = async () => {
        if (resendDisabled) return;

        try {
            await sendOTP();
            toast.success('OTP has been resent to your email', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            console.log("OTP has been resent to your email.");
        } catch (error) {
            console.error("Error resending OTP:", error);
            console.log("Failed to resend OTP. Please try again later.");
        }
    };
    // Function to send OTP via email
    const sendOTP = async () => {
        console.log("Sending OTP to email:", formData.email);

        try {
            // Call to your backend API to send OTP via email
            const response = await fetch(
                process.env.REACT_APP_APIURL + "business/resendotp",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({

                        email_address: formData.email,
                        first_name: formData.firstName,
                        last_name: formData.lastName,
                    }),
                }
            );

            if (!response.ok) {
                throw new Error(`Failed to send OTP with status: ${response.status}`);
            }
            console.log("Date response", response);

            setResendDisabled(true);
            setResendTimer(60);

            return await response.json();
        } catch (error) {
            console.error("Error sending email OTP:", error);
            throw error;
        }
    };
    const handleOtpChange = (value) => {

        setOtp(value);
        if (value.length === 4) {
            setOtp(value)
            verifyOTP(value);
        }
    };
    const options = indianStatesWithDetails.map(state => ({
        value: state.state,
        label: state.state
    }));

    return (
        <>
            {!showOtpSection ? (

                <div className="registration-container">

                    <form onSubmit={handleSubmit} className="registration-card">
                        <div className="form-section general-info" >
                            <div className="signup-header">
                                <a href="/" className="login_logo">
                                    <img
                                        src="assets/img/logoblack.png"
                                        alt="Logo"
                                    />
                                </a>
                            </div>
                            <h2>General Information</h2>

                            <div className="form-row">

                                <div className="input-group">
                                    <label>
                                        First Name <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        placeholder="First Name"
                                        className={`form-input ${errors.firstName ? "error" : ""}`}
                                        value={formData.firstName}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Only allow letters and spaces
                                            if (/^[A-Za-z\s]*$/.test(value)) {
                                                setFormData({ ...formData, firstName: value });
                                                setErrors({ ...errors, firstName: "" });
                                            } else {
                                                setErrors({ ...errors, firstName: "Only letters are allowed" });
                                            }
                                        }}
                                        style={{ cursor: "default" }}
                                    />
                                    {errors.firstName && (
                                        <span className="error-message" style={{ bottom: "-22px" }}>
                                            {errors.firstName}
                                        </span>
                                    )}
                                </div>

                                <div className="input-group">
                                    <label>
                                        Last Name <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="lastName"
                                        placeholder="Last Name"
                                        className={`form-input ${errors.lastName ? "error" : ""}`}
                                        value={formData.lastName}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Only allow letters and spaces
                                            if (/^[A-Za-z\s]*$/.test(value)) {
                                                setFormData({ ...formData, lastName: value });
                                                setErrors({ ...errors, lastName: "" });
                                            } else {
                                                setErrors({ ...errors, lastName: "Only letters are allowed" });
                                            }
                                        }}
                                        style={{ cursor: "default" }}
                                    />
                                    {errors.lastName && (
                                        <span className="error-message" style={{ bottom: "-22px" }}>
                                            {errors.lastName}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="input-group">
                                <label>
                                    Email <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    className={`form-input ${errors.email ? "error" : ""}`}
                                    value={formData.email}
                                    onChange={(e) =>
                                        handleChange({
                                            target: { name: "email", value: e.target.value.toLowerCase() },
                                        })
                                    }

                                    style={{ marginBottom: "26px", cursor: "default" }}
                                />
                                {errors.email && (
                                    <span className="error-message" style={{ bottom: "1px" }}>
                                        {errors.email}
                                    </span>
                                )}
                            </div>

                           <div className="form-row">
  {/* Password Field */}
  <div className="input-group" style={{ position: "relative" }}>
    <label>
      Password <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type={showPassword ? "text" : "password"}
      name="password"
      placeholder="Password"
      className={`form-input ${errors.password ? "error" : ""}`}
      value={formData.password}
      onChange={handleChange}
      maxLength={15}
      style={{ cursor: "default" }}
    />
    {/* Eye Icon */}
    <div
      style={{
        position: "absolute",
        right: "10px",
        top: "70%",
        transform: "translateY(-50%)",
        cursor: "pointer",
      }}
      onClick={() => setShowPassword(!showPassword)}
    >
      <i className={showPassword ? "fas fa-eye" : "fas fa-eye-slash"} />
    </div>

    {errors.password && (
      <span className="error-message">{errors.password}</span>
    )}

    {/* Password Requirements */}
    <div className="password-requirements" style={{ marginTop: "120px" }}>
      <div className={passwordRequirements.length ? "met" : ""}>
        • 8 characters minimum
      </div>
      <div className={passwordRequirements.number ? "met" : ""}>
        • 1 number
      </div>
      <div className={passwordRequirements.capital ? "met" : ""}>
        • 1 capital letter
      </div>
      <div className={passwordRequirements.special ? "met" : ""}>
        • 1 special character
      </div>
    </div>
  </div>


                             {/* Confirm Password Field */}
  <div className="input-group" style={{ position: "relative" }}>
    <label>
      Confirm Password <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type={showConfirmPassword ? "text" : "password"}
      name="confirmPassword"
      placeholder="Confirm Password"
      className={`form-input ${errors.confirmPassword ? "error" : ""}`}
      value={formData.confirmPassword}
      onChange={handleChange}
      maxLength={15}
      style={{ cursor: "default" }}
    />
    {/* Eye Icon */}
    <div
      style={{
        position: "absolute",
        right: "10px",
        top: "70%",
        transform: "translateY(-50%)",
        cursor: "pointer",
      }}
      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
    >
      <i className={showConfirmPassword ? "fas fa-eye" : "fas fa-eye-slash"} />
    </div>

    {errors.confirmPassword && (
      <span className="error-message">{errors.confirmPassword}</span>
    )}
  </div>
</div>
                        </div>
                        {/* Right Section - Business Details */}

                        <div className="form-section contact-details">

                            <h2>Business Details</h2>

                            <div className="form-group">
                                <label>
                                    Business Name<span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    name="businessName"
                                    placeholder="Business Name"
                                    className="form-input"
                                    value={formData.businessName}
                                    onChange={handleChange}
                                    onInput={(e) =>
                                        (e.target.value = e.target.value.replace(/[0-9]/g, ""))
                                    }
                                    required
                                    style={{ cursor: "default" }}
                                />
                            </div>

                            <div className="form-group">
                                <label>
                                    phone Number<span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    name="phoneNumber"
                                    placeholder="Phone Number"
                                    className="form-input"
                                    value={formData.phoneNumber}
                                    onChange={handleChange}
                                    onInput={(e) =>
                                        (e.target.value = e.target.value.replace(/\D/g, ""))
                                    }
                                    maxLength={10}
                                    required
                                    style={{ cursor: "default" }}
                                />
                            </div>

                            <div className="form-group">
                                <label>
                                    Address<span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    name="address"
                                    placeholder="Address"
                                    className="form-input"
                                    value={formData.address}
                                    onChange={handleChange}
                                    required
                                    style={{ cursor: "default" }}
                                />
                            </div>

                            <div className="form-row">
                                <div className="form-group" style={{ flex: 1, marginRight: "10px" }}>
                                    <label>
                                        State <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                        options={options}
                                        value={options.find(option => option.value === formData.state)}
                                        onChange={selectedOption => handleChange({ target: { name: "state", value: selectedOption.value } })}
                                        isSearchable
                                        styles={{
                                            control: (base) => ({ ...base, height: 45, borderRadius: 5, cursor: 'pointer', }),
                                            menu: (base) => ({ ...base, maxHeight: "200px", overflowY: "auto", color: 'black', })
                                        }}
                                        placeholder="Select State"
                                    />
                                </div>



                                <div className="form-group" style={{ flex: 1 }}>
                                    <label>
                                        ZIP Code <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="zipCode"
                                        placeholder="ZIP Code"
                                        className={`form-input ${errors.zipCode ? "error" : ""}`}
                                        value={formData.zipCode}
                                        onChange={handleChange}
                                        maxLength={6}
                                        onInput={(e) => (e.target.value = e.target.value.replace(/\D/g, ""))}
                                        required
                                        style={{ cursor: "default" }}
                                    />
                                    {errors.zipCode && (
                                        <span className="error-message" style={{ bottom: "-34px" }}>
                                            {errors.zipCode}
                                        </span>
                                    )}
                                </div>
                            </div>



                            <div className="terms-group" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <input
                                    type="checkbox"
                                    id="terms"
                                    name="terms"
                                    className="form-checkbox"
                                    checked={formData.terms}
                                    onChange={handleChange}
                                    required
                                    style={{ cursor: "pointer" }}
                                />
                                <label htmlFor="terms" style={{ margin: 0 }}>
                                    I accept the{" "}
                                    <a
                                        href="https://www.eventseasy.in/terms_condition"
                                        className="terms-link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Terms and Conditions
                                    </a>
                                </label>
                            </div>
                            {errors.terms && (
                                <span className="error-message">{errors.terms}</span>
                            )}


                            <div className="web-store-option">
                                <div className="d-flex align-items-start">
                                    <input
                                        type="checkbox"
                                        id="createWebStore"
                                        name="createWebStore"
                                        className="form-check-input mt-2 me-2"
                                        checked={formData.createWebStore}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="createWebStore" className="web-store-label">
                                        <div className="web-store-content">
                                            <strong>Create a Web Store</strong>
                                            <p>Get your own online storefront to showcase and sell your products</p>
                                        </div>
                                    </label>
                                </div>

                                {formData.createWebStore && (
                                    <div className="web-store-benefits">
                                        <div className="benefit-item">
                                            <i className="fas fa-store"></i>
                                            <span>Custom domain: businessname.eventseasy.in</span>
                                        </div>
                                        <div className="benefit-item">
                                            <i className="fas fa-palette"></i>
                                            <span>Customizable colors and branding</span>
                                        </div>
                                        <div className="benefit-item">
                                            <i className="fas fa-shopping-cart"></i>
                                            <span>Integrated shopping cart</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <p style={{ color: "red;" }}>{errorResponce}</p>

                            <button
                                type="submit"
                                className="register-button"
                                disabled={isSubmitting}
                                style={{ marginTop: '-1px' }}
                            >
                                {isSubmitting ? "Continuing..." : "Continue"}
                            </button>
                            <div className='already-user' style={{ marginTop: '10px' }}>
                                <p style={{ fontOpticalSizing: '8px' }}>Already have an account?<a href="/login" style={{ paddingLeft: '5px' }}>sign In</a> </p>
                            </div>
                        </div>

                    </form>
                    <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                    />
                </div>


            ) : (
                <div className="registration-card otp-verification">
                    <h2>Verify Your Email</h2>
                    <p>
                        We've sent a 4-digit verification code to{" "}
                        <strong>{formData.email}</strong>
                    </p>
                    <p className="otp-instruction">
                        Please check your inbox and enter the code below
                    </p>

                    <div className="otp-input-container" style={{ marginLeft: '140px' }}>
                        <OtpInput
                            value={otp}
                            onChange={handleOtpChange}
                            numInputs={4}
                            renderInput={(props) => <input {...props} />}
                            separator={<span className="mx-2">-</span>}
                            shouldAutoFocus={true}
                            containerStyle="justify-center gap-2"
                            inputStyle={{
                                width: '50px',
                                height: '50px',
                                margin: '0 5px',
                                fontSize: '18px',
                                borderRadius: '8px',
                                border: '1px solid #ccc',
                                backgroundColor: 'white',  // Explicitly set background
                                color: '#000',            // Explicitly set text color
                                textAlign: 'center'
                            }}
                        />
                    </div>

                    <div className="otp-actions">
                        <button
                            type="button"
                            className="verify-button"
                            onClick={verifyOTP}
                            disabled={isSubmitting || otp.length !== 4}
                        >
                            {isSubmitting ? "Verifying..." : "Verify & Complete Registration"}
                        </button>

                        <div className="resend-container">
                            <button
                                type="button"
                                className={`resend-button ${resendDisabled ? "disabled" : ""}`}
                                onClick={handleResendOTP}
                                disabled={resendDisabled}
                            >
                                {resendDisabled
                                    ? `Resend code in ${resendTimer}s`
                                    : "Resend verification code"}
                            </button>
                        </div>

                        {/* <button
                            type="button"
                            className="back-button"
                            onClick={() => setShowOtpSection(false)}
                        >
                            Back to Form
                        </button> */}
                    </div>
                    <ToastContainer
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                    />
                </div>

            )}
        </>
    );
};

export default RegistrationForm;
